import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiCallStatus } from 'helpers/constants';
import { GeneralDialog, LoadingStatusWrapper } from 'sharedComponents';
import ErrorView from 'sharedComponents/ErrorBoundary/ErrorView';
import { useReportIssue } from 'sharedHooks/useReportIssue';
import { getDefaultDateSelection } from '../../helpers';
import './styles.scss';
import moment from 'moment';

const DownloadMeasurementsComponent = (props) => {
    const { t: translate } = useTranslation();
    const { showReportIssue } = useReportIssue();
    const { model, actions } = props;
    const {
        measurementTypeIds,
    } = model.measurementDownloadDialogParams;
    const isExportError = model.measurementExportErrorData?.loadingStatus === apiCallStatus.ERROR;

    const handleExport = () => {
        return actions.exportExcelForMeasurementTypeGroup(model.asset,
            {
                measurementTypes: measurementTypeIds,
                from: moment(model.dateSelection.from || getDefaultDateSelection().from).format(),
                to: moment(model.dateSelection.to || getDefaultDateSelection().to).format(),
                clientTimeZoneOffset: new Date().getTimezoneOffset()
            }).then(() => props.close())
            .catch(() => { });
    };

    return <GeneralDialog
        show={props.show}
        close={props.close}
        title={translate('ABB.Powertrain.Frontend.exportMeasurementsConfirmationTitle')}
        dialogClassName='download-measurements-dialog'
        cancelButtonProps={{
            text: translate('ABB.Powertrain.Frontend.cancelLabel'),
            onClick: () => { }
        }}
        acceptButtonProps={{
            disabled: model.trendKpisLoadingStatus === apiCallStatus.LOADING || model.measurementExportLoadingStatus === apiCallStatus.LOADING || isExportError,
            text: translate('ABB.Powertrain.Frontend.okLabel'),
            onClick: handleExport
        }}
        closeButton={true}
    >
        <LoadingStatusWrapper loadingStatus={[model.measurementExportLoadingStatus, model.trendKpisLoadingStatus]}>
            {isExportError ?
                <ErrorView
                    errorCode={model.measurementExportErrorData.errorCode}
                    onRetry={() => actions.clearMeasurementExportError()}
                    onReportIssue={showReportIssue}
                />
                : <div className='export-measurement-description'>
                    {translate('ABB.Powertrain.Frontend.exportMeasurementsConfirmationDescription')}
                </div>
            }
        </LoadingStatusWrapper>
    </GeneralDialog>;
};

DownloadMeasurementsComponent.propTypes = {
    actions: PropTypes.shape({
        exportExcelForMeasurementTypeGroup: PropTypes.func,
        clearMeasurementExportError: PropTypes.func
    }),
    close: PropTypes.func,
    model: PropTypes.shape({
        asset: PropTypes.any,
        dateSelection: PropTypes.shape({
            from: PropTypes.any,
            to: PropTypes.any
        }),
        measurementDownloadDialogParams: PropTypes.shape({
            measurementTypeIds: PropTypes.array
        }),
        measurementExportLoadingStatus: PropTypes.string,
        measurementExportErrorData: PropTypes.shape({
            loadingStatus: PropTypes.string,
            errorCode: PropTypes.number,
            error: PropTypes.object
        }),
        trendKpisLoadingStatus: PropTypes.string
    }),
    show: PropTypes.bool
};

export default DownloadMeasurementsComponent;
